import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ImportarService } from '../../services/importar.service';
import { ApiResult } from '../../models/ApiResult';
import { element } from 'protractor';
import { ResultadoImportModel } from '../../models/ErroresImportModel';

@Component({
  selector: 'app-importar',
  templateUrl: './importar.component.html',
  styleUrls: ['./importar.component.scss']
})
export class ImportarComponent implements OnInit {

  @Input() typeImport: string;
  @Input() idAux: string;
  //fileToUpload: File = null;
  uploadMultiple = false;
  filesToUpload: FileList = null;
  error: string = null;
  mensajes: string = null;
  matProgressVisible = false;
  matProgressValue: number = 0;

  resultadoImport: ResultadoImportModel[];

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute,
    public _authService: AuthService, private _router: Router,
    private importarservice: ImportarService
    ) {}

  ngOnInit() {
    this.uploadMultiple = (!this.idAux);

  }

  handleFileInput(files: FileList) {
    //this.fileToUpload = files.item(0);
    this.filesToUpload = files;
  }

  async uploadFileToActivity() {
    this.matProgressVisible = true;
    this.matProgressValue = 0;
    let nFiles = this.filesToUpload.length;
    this.resultadoImport = new Array<ResultadoImportModel>();

    for (let i = 0; i < nFiles; i++) {
      let file = this.filesToUpload.item(i);

      try {
        if(this.typeImport === "expediente"){
          let resp = await this.importarservice.uploadArchivo(file, "api/Importacion/UploadExcelExpediente", this.idAux).toPromise();
          this.resultadoImport.push(resp);

        } else {
          let resp = await this.importarservice.uploadArchivo(file).toPromise();

          this.resultadoImport.push(resp);
        }
        let progressValue = ((i+1) / nFiles) * 100;
        // convert progressValue to integer
        this.matProgressValue = Math.round(progressValue);

      }
      catch (error) {
        console.log(error);
        this.error = 'Error inesperado';
      }
    }
    this.matProgressValue = 100;
    this.matProgressVisible = false;

  }

}
